import type { JSONContent } from '@tiptap/vue-3'

export const parseEditorContent = (content: string | undefined): JSONContent | string | null => {
  if (content) {
    try {
      return JSON.parse(content)
    } catch {
      return content
    }
  }
  return ''
}
